export const MICROPHONE_REQUEST_DECISION = 'MICROPHONE_REQUEST_DECISION';
